import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userToken: null,
  current_user: {},
  ixBiz: 0,
  sandbox: 0
};

const slice = createSlice({
  name: 'socketStates',
  initialState,
  reducers: {
    setSocketAuth(state, action) {
      state.userToken = action.payload.token;
      state.current_user = action.payload.current_user;
      state.ixBiz = action.payload.biz;
      state.sandbox = action.payload.sandbox ?? 0;
    },
    setUserToken(state, action) {
      state.userToken = action.payload;
    },
    setSandbox(state, action) {
      state.sandbox = action.payload?.ixSandbox ?? 0;
    },
    setCurrentUser(state, action) {
      state.current_user = action.payload;
    },
    setIxBiz(state, action) {
      state.ixBiz = action.payload?.ixBiz ?? 0;
    },
    resetSocketState(state) {
      state.userToken = null;
      state.current_user = {};
      state.ixBiz = 0;
      state.sandbox = 0;
    }
  }
});
const socketReducer = slice.reducer;
export const {
  setSocketAuth,
  setUserToken,
  setSandbox,
  setCurrentUser,
  setIxBiz,
  resetSocketState
} = slice.actions;

export default socketReducer;
